/**
 * Floating WhatsApp Support Button.
 * Provides an omnipresent, accessible 1-click connection to customer support on WhatsApp.
 */

import { useState } from "react";

const WHATSAPP_PHONE = "919344580982";
const DEFAULT_MESSAGE = "Hello Aster Decorz! 👋 I would like to inquire about your botanical collections / order support.";

export function WhatsAppSupportButton() {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <aside
      aria-label="Customer support"
      className="fixed bottom-20 right-4 z-40 md:bottom-6 md:right-6 flex items-center print:hidden"
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative flex items-center gap-2.5 rounded-full bg-[#25D366] p-3 md:p-3.5 text-white shadow-lg shadow-[#25D366]/30 transition-all duration-300 hover:bg-[#20ba5a] hover:shadow-xl hover:scale-105 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366]"
        aria-label="Chat with Aster Decorz on WhatsApp (+91 9344580982)"
      >
        {/* Pulsing online status indicator */}
        <span className="absolute -top-1 -right-1 flex h-3.5 w-3.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex h-3.5 w-3.5 rounded-full border-2 border-white bg-emerald-500" />
        </span>

        {/* WhatsApp Vector Icon */}
        <svg
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="currentColor"
          className="h-6 w-6 shrink-0 transition-transform duration-300 group-hover:rotate-6"
          aria-hidden="true"
        >
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.05 20.16C10.57 20.16 9.12 19.76 7.85 19.01L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 14.99 3.8 13.47 3.8 11.91C3.8 7.37 7.5 3.67 12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.16 12.05 20.16ZM16.57 14.39C16.32 14.26 15.1 13.66 14.87 13.58C14.65 13.5 14.49 13.46 14.32 13.71C14.16 13.96 13.7 14.49 13.55 14.66C13.41 14.82 13.26 14.85 13.01 14.72C12.77 14.6 11.98 14.34 11.05 13.51C10.33 12.86 9.84 12.06 9.69 11.82C9.55 11.57 9.68 11.43 9.8 11.31C9.91 11.2 10.05 11.02 10.17 10.88C10.29 10.74 10.33 10.63 10.41 10.47C10.49 10.31 10.45 10.17 10.39 10.05C10.33 9.93 9.84 8.73 9.63 8.23C9.43 7.75 9.23 7.81 9.08 7.81C8.93 7.8 8.77 7.8 8.61 7.8C8.44 7.8 8.17 7.86 7.94 8.11C7.72 8.36 7.08 8.96 7.08 10.18C7.08 11.4 7.97 12.57 8.09 12.74C8.21 12.9 9.83 15.4 12.32 16.47C12.91 16.73 13.37 16.88 13.73 16.99C14.32 17.18 14.86 17.15 15.29 17.09C15.77 17.02 16.76 16.49 16.97 15.91C17.17 15.34 17.17 14.85 17.11 14.75C17.05 14.65 16.82 14.51 16.57 14.39Z" />
        </svg>

        {/* Desktop Expandable Badge */}
        <span
          className={`hidden md:inline-block max-w-0 overflow-hidden whitespace-nowrap text-xs font-bold uppercase tracking-wider transition-all duration-300 ease-in-out ${
            isHovered ? "max-w-xs pr-2" : ""
          }`}
        >
          Chat with us
        </span>
      </a>
    </aside>
  );
}
